module.exports = __webpack_public_path__ + "img/sol_cap4.37a37ae7.png";